export const reconciliationConstants = {
    // Loading reconciliations
    LOAD_RECONCILIATIONS_REQUEST: 'LOAD_RECONCILIATIONS_REQUEST',
    LOAD_RECONCILIATIONS_SUCCESS: 'LOAD_RECONCILIATIONS_SUCCESS',
    LOAD_RECONCILIATIONS_FAILURE: 'LOAD_RECONCILIATIONS_FAILURE',

    // // Reconcile
    // RECONCILE_REQUEST: 'RECONCILE_REQUEST',
    // RECONCILE_SUCCESS: 'RECONCILE_SUCCESS',
    // RECONCILE_FAILURE: 'RECONCILE_FAILURE'
}


// WEBPACK FOOTER //
// ./src/redux/constants/reconciliation.constants.js